import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{staticClass:"mx-auto",attrs:{"flat":""}},[_c(VCardTitle,[_vm._v("Number of Items Per Category "),_c(VSpacer)],1),_c(VCardText,[_c('PieChart',{attrs:{"pieData":_vm.pieData}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }